<template>
	<div id="voiceExam">
    <el-steps :active="stepactive" finish-status="success" simple style="margin: 20px 0;">
      <el-step title="功能学习" @click.native="stepactive >= 2 && showStep(1)"></el-step>
      <el-step title="测试须知" @click.native="stepactive >= 2 && showStep(2)"></el-step>
      <el-step title="开始测试" @click.native="stepactive >= 3 && showStep(3)"></el-step>
      <el-step title="测试合格" @click.native="stepactive >= 4 && showStep(4)"></el-step>
    </el-steps>
    <div class="js-video" v-if="clickFlag == 1">
      <p class="red">温馨提示：语音客服必须掌握小助手的功能，请认真观看视频，学完所有功能，不要快进，否则不能正常进入下一步。</p>
      <el-tabs tab-position="left" v-model="tabCurrent" @tab-click="handleClick">
        <!--第1个视频-->
        <el-tab-pane name="first">
          <div slot="label" class="tab-slot">
            <p class="title">打卡</p>
          </div>
          <div id="video-first" class="video-box">
            <video id="first" src="https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/1.%E6%89%93%E5%8D%A1.mp4" controls="controls" class="video">
              您的浏览器不支持 video 标签。
            </video>
          </div>
          <div id="stoptip-first" class="stoptip">
            <div class="tip">
              <span class="el-icon-success"></span>
              <p>视频学习完毕</p>
              <p>
                <a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
                <a class="startstudy" @click="studyNext('#tab-second')">继续下一步学习</a>
              </p>
            </div>
          </div>
        </el-tab-pane>
        <!--第2个视频-->
        <el-tab-pane name="second">
          <div slot="label" class="tab-slot">
            <p class="title">领数据外呼</p>
          </div>
          <div id="video-second" class="video-box">
            <video id="second" src="https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/2.%E9%A2%86%E6%95%B0%E6%8D%AE%E5%A4%96%E5%91%BC.mp4" controls="controls" class="video">
              您的浏览器不支持 video 标签。
            </video>
          </div>
          <div id="stoptip-second" class="stoptip">
            <div class="tip">
              <span class="el-icon-success"></span>
              <p>视频学习完毕</p>
              <p>
                <a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
                <a class="startstudy" @click="studyNext('#tab-third')">继续下一步学习</a>
              </p>
            </div>
          </div>
        </el-tab-pane>
        <!--第3个视频-->
        <el-tab-pane name="third">
          <div slot="label" class="tab-slot">
            <p class="title">修改客户资料</p>
          </div>
          <div id="video-third" class="video-box">
            <video id="third" src="https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/3.%E4%BF%AE%E6%94%B9%E5%AE%A2%E6%88%B7%E8%B5%84%E6%96%99.mp4" controls="controls" class="video">
              您的浏览器不支持 video 标签。
            </video>
          </div>
          <div id="stoptip-third" class="stoptip">
            <div class="tip">
              <span class="el-icon-success"></span>
              <p>视频学习完毕</p>
              <p>
                <a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
                <a class="startstudy" @click="studyNext('#tab-four')">继续下一步学习</a>
              </p>
            </div>
          </div>
        </el-tab-pane>
        <!--第4个视频-->
        <el-tab-pane name="four">
          <div slot="label" class="tab-slot">
            <p class="title">下载录音</p>
          </div>
          <div id="video-four" class="video-box">
            <video id="four" src="https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/4.%E4%B8%8B%E8%BD%BD%E5%BD%95%E9%9F%B3.mp4" controls="controls" class="video">
              您的浏览器不支持 video 标签。
            </video>
          </div>
          <div id="stoptip-four" class="stoptip">
            <div class="tip">
              <span class="el-icon-success"></span>
              <p>视频学习完毕</p>
              <p>
                <a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
                <a class="startstudy" @click="studyNext('#tab-five')">继续下一步学习</a>
              </p>
            </div>
          </div>
        </el-tab-pane>
        <!--第5个视频-->
        <el-tab-pane name="five">
          <div slot="label" class="tab-slot">
            <p class="title">呼入操作</p>
          </div>
          <div id="video-five" class="video-box">
            <video id="five" src="https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/5.%E5%91%BC%E5%85%A5%E6%93%8D%E4%BD%9C.mp4" controls="controls" class="video">
              您的浏览器不支持 video 标签。
            </video>
          </div>
          <div id="stoptip-five" class="stoptip">
            <div class="tip">
              <span class="el-icon-success"></span>
              <p>视频学习完毕</p>
              <p>
                <a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
                <a class="startstudy" @click="studyNextLast">进入测试须知</a>
              </p>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--测试须知-->
    <div class="warp" v-if="clickFlag == 2">
      <div class="box">
        <div class="title">
          <span class="dot"></span><span class="dot big"></span><span class="dot bigger"></span>
          <span>测试目的</span>
          <span class="dot bigger"></span><span class="dot big"></span><span class="dot"></span>
        </div>
        <div class="whitebg">
          <p><span class="dot big"></span>检测您是否掌握了小助手的使用方法</p>
          <p><span class="dot big"></span>检测您是否符合语音客服的条件</p>
        </div>
        <div class="whitebg flex">
          <div class="left">
            <p>
              <span class="type">设备要求</span>
              <span>必须要有耳麦</span>
            </p>
            <p class="mt">
              <span class="type">测试时间</span>
              <span>9:00-17:30</span>
            </p>
            <p class="mt">
              <span class="type">测试机会</span>
              <span>每人每天有一次测试机会</span>
            </p>
            <p class="mt">
              <span class="type">测试结果</span>
              <span>当天18点前会出测试结果</span>
            </p>
          </div>
          <div class="right">
            <p><span class="type">合格标准</span></p>
            <p>1、完成当天的测试外呼量（10通电话）</p>
            <p>2、普通话良好</p>
            <p>3、耳麦没有回音、杂音</p>
            <p>4、话术流畅、灵活性强</p>
          </div>
        </div>
        <div class="title">
          <span class="dot"></span><span class="dot big"></span><span class="dot bigger"></span>
          <span>操作说明</span>
          <span class="dot bigger"></span><span class="dot big"></span><span class="dot"></span>
        </div>
        <div class="whitebg">
          <p class="red">温馨提示：请认真观看视频，不然你不知道接下来应该怎么做！</p>
          <video src="https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWebTjk/webVideo/6.%E7%B3%BB%E7%BB%9F%E6%B5%8B%E8%AF%95.mp4" controls="controls" class="video">
            您的浏览器不支持 video 标签。
          </video>
        </div>test-guide
        <div class="title">
          <span class="dot"></span><span class="dot big"></span><span class="dot bigger"></span>
          <span>温馨提示</span>
          <span class="dot bigger"></span><span class="dot big"></span><span class="dot"></span>
        </div>
        <div class="whitebg">
          <p>系统测试时，请保持您的电话畅通；</p>
          <p>如果您的耳麦有问题，我们平台的工作人员会电话联系您（为了您能顺利通过测试，请不要拒接，谢谢）；</p>
          <p>电话联系不上您时，我们会在APP上的消息中私信您，或者发送系统消息通知您，请注意查看信息。</p>
          <p class="blue">*ps：外呼过程中，有任何的问题，可以点击小助手上的“在线沟通”，在“今日系统测试咨询群”反馈。</p>
        </div>
      </div>
      <el-button class="btn hui" type="primary" v-if="miaoone !== 0 && stepactive == 2">我已知晓({{ miaoone }}s)</el-button>
      <el-button class="btn" type="primary" v-else @click="goNext">我已知晓</el-button>
    </div>
    <!--操作说明-->
    <div class="opertionbg" v-if="(isShowStepOne || isShowStepTwo || isShowStepThird || isShowStepFour) && clickFlag === 3 && stepactive === 3"></div>
    <div class="opertiontip-box" v-if="isShowStepOne && clickFlag === 3 && stepactive === 3">
      <div class="opertiontip">
        <div class="step-tip">
          <span class="red">*注意：外呼测试的时候，接听对象是机器人，必须要用这个话术，才能和机器人进行对话，否则测试不合格！（右侧有录音参考）</span>
        </div>
      </div>
      <div class="tip-quan">
        <img src="../../../static/tip-quan-up.png" />
      </div>
      <div class="tip-text">
        <p>请认真阅读注意事项！</p>
        <el-button class="btn" type="primary" @click="showStepTwo">下一步</el-button>
      </div>
    </div>
    <div class="opertiontip-box tip-two" v-if="isShowStepTwo && clickFlag === 3 && stepactive === 3">
      <div class="opertiontip">
        <div class="step-tip">
          <audio src="http://res.study.itaojin.cn/2020-09/luyinanli.mp3?version=0821" controls="controls"></audio>
        </div>
      </div>
      <div class="tip-quan">
        <img src="../../../static/tip-quan-up.png" />
      </div>
      <div class="tip-text">
        <p>这是一段优秀录音，请认真学习！</p>
        <el-button class="btn" type="primary" @click="showStepThird">下一步</el-button>
      </div>
    </div>
    <div class="opertiontip-box tip-third" v-if="isShowStepThird && clickFlag === 3 && stepactive === 3">
      <div class="tip-text">
        <p>以下是参考话术，测试时需要使用此话术</p>
        <el-button class="btn" type="primary" @click="showStepFour">下一步</el-button>
      </div>
      <div class="tip-quan">
        <img src="../../../static/tip-quan-down.png" />
      </div>
      <div class="opertiontip">
        <div class="step-tip">
          <table class="huashu">
            <thead>
              <tr>
                <th width="120"></th>
                <th width="200">步骤</th>
                <th>客服参考话术</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="blue">开场白</td>
                <td class="black">核对尾号，确认机主</td>
                <td>您好！我是淘金平台的工作人员，请问您是手机尾号****的机主吗？</td>
              </tr>
              <tr>
                <td class="blue">探寻需求</td>
                <td class="black">询问任务意向</td>
                <td>今天给您致电是想做一个简单的回访，我们平台有语音客服任务、在线客服任务、标注客服任务，请问您是想做哪种类型的任务呢？</td>
              </tr>
              <tr>
                <td rowspan="2" class="blue">推荐产品</td>
                <td class="black">普通话好引导做语音</td>
                <td>我听您普通话不错的，您可以考虑下做语音的任务，语音任务时薪报酬要比在线多几倍呢。</td>
              </tr>
              <tr>
                <td class="black">获得徽章就可领任务</td>
                <td>好的，您可以在手机APP上完成语音基础培训，获得语音上岗徽章就可以申请语音的任务。</td>
              </tr>
              <tr>
                <td rowspan="2" class="blue">异议处理</td>
                <td class="black">对方想做语音</td>
                <td>好的，请问您之前是有做过语音客服相关的工作吗？您可以在手机APP上完成语音基础培训，获得语音徽章就可以申请语音的任务。</td>
              </tr>
              <tr>
                <td class="black">对方不想做语音</td>
                <td>好的，是您那边环境不适合做语音吗？那您可以在APP上完成在线基础培训，获得相关的在线徽章就可以申请在线的任务。</td>
              </tr>
              <tr>
                <td class="blue">结束语</td>
                <td class="black"></td>
                <td>请尽快去APP上学习，我就不打扰您了，感谢您的接听，祝您生活愉快，再见！</td>
              </tr>
              <tr>
                <td rowspan="11" class="blue">其<br />他<br />常<br />见<br />问<br />题</td>
                <td class="black">有工作，没时间</td>
                <td>好的，您以后有需要了欢迎您随时回来。</td>
              </tr>
              <tr>
                <td class="black">有工作但晚上有时间</td>
                <td>您这种情况呢，我这边是建议您可以尝试做在线客服，在线任务的时间安排相对来说更自由一些。</td>
              </tr>
              <tr>
                <td class="black">询问工资怎么计算</td>
                <td>报酬是根据任务而定的，不同的任务，报酬也不同；常见的形式是时薪。</td>
              </tr>
              <tr>
                <td class="black">培训收费吗</td>
                <td>您放心，我们平台承诺大家在整个过程中都是完全免费的，不收取任何一分钱的费用。</td>
              </tr>
              <tr>
                <td class="black">什么是在线客服？</td>
                <td>在线客服主要是通过文字和顾客交流，跟淘宝上的客服一样的。</td>
              </tr>
              <tr>
                <td class="black">什么是语音客服？</td>
                <td>语音客服主要是通过电话和顾客交流，就是电话销售。</td>
              </tr>
              <tr>
                <td class="black">学习课程中有问题</td>
                <td>这个情况的话，您可以在APP上反馈给班主任，班主任那边可以帮您解决。</td>
              </tr>
              <tr>
                <td class="black">已经上岗</td>
                <td>好的，如果您执行任务中有任务问题，都可以直接反馈给主管，那我就不打扰您了，祝您生活愉快，再见！</td>
              </tr>
              <tr>
                <td class="black">是我家人注册的</td>
                <td>那您知道您家人是想在我们平台做语音客服还是在线客服吗？目前是否已经上岗了呢？</td>
              </tr>
              <tr>
                <td class="black">做不好会有扣罚吗</td>
                <td>这个也是视任务而定的，等申请任务之后，任务老师也会给您们提前说明扣罚的。</td>
              </tr>
              <tr>
                <td class="black">我随便下载的，我不清楚你们是做什么的</td>
                <td>我简单的给您介绍下我们平台，我们淘金是2015年成立，是客服外包平台，客服是在家执行任务，获得报酬，而且我们的任务大多是长期的，在家就可以在平台上获得稳定的收入，我们执行任务的时间也比较灵活，您可以用您平时的空闲时间来平台做任务。</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- <div class="opertiontip-box tip-four" v-if="isShowStepFour && clickFlag === 3 && stepactive === 3">
      <div class="tip-text">
        <p>学习时间180秒后可以开始测试</p>
        <el-button class="btn" type="primary" @click="closeStep">确定</el-button>
      </div>
      <div class="tip-quan">
        <img src="../../../static/tip-quan-down.png" />
      </div>
      <div class="opertiontip">
        <div class="step-tip">
          <div class="result" v-if="status == 'AlreadyTheoryBadge' || status == 'NoTheoryBadge'">
            <p class="tip">温馨提示：<font color="red"><b>每天只能进行一次测试，外呼时请参考话术内容。</b></font>准备好即可开始测试，请珍惜测试机会。</p>
          </div>
          <div class="result" v-if="status == 'Failed'">
            <p class="failtext">很遗憾，测试未通过！</p>
            <div class="reason">未通过原因：<span v-html="result"></span></div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="opertion warp" v-if="clickFlag == 3">
        <div class="box">
          <div class="title">
            <span class="dot"></span><span class="dot big"></span><span class="dot bigger"></span>
            <span>话术参考</span>
            <span class="dot bigger"></span><span class="dot big"></span><span class="dot"></span>
          </div>
          <div class=" Addmodifications">
            <div class="audio-box">
              <div>
                <div class="red text-font">*注意：外呼测试的时候，接听对象是机器人，必须要用这个话术，才能和机器人进行对话，否则测试不合格！（右侧有录音参考）</div>
              </div>
              <audio src="http://res.study.itaojin.cn/2020-09/luyinanli.mp3?version=0821" controls="controls"></audio>
            </div>
            <table class="huashu">
              <thead>
                <tr>
                  <th width="120"></th>
                  <th width="200">步骤</th>
                  <th>客服参考话术</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="blue">开场白</td>
                  <td class="black">核对尾号，确认机主</td>
                  <td>您好！我是淘金平台的工作人员，请问您是手机尾号****的机主吗？</td>
                </tr>
                <tr>
                  <td class="blue">探寻需求</td>
                  <td class="black">询问任务意向</td>
                  <td>今天给您致电是想做一个简单的回访，我们平台有语音客服任务、在线客服任务、标注客服任务，请问您是想做哪种类型的任务呢？</td>
                </tr>
                <tr>
                  <td rowspan="2" class="blue">推荐产品</td>
                  <td class="black">普通话好引导做语音</td>
                  <td>我听您普通话不错的，您可以考虑下做语音的任务，语音任务时薪报酬要比在线多几倍呢。</td>
                </tr>
                <tr>
                  <td class="black">获得徽章就可领任务</td>
                  <td>好的，您可以在手机APP上完成语音基础培训，获得语音上岗徽章就可以申请语音的任务。</td>
                </tr>
                <tr>
                  <td rowspan="2" class="blue">异议处理</td>
                  <td class="black">对方想做语音</td>
                  <td>好的，请问您之前是有做过语音客服相关的工作吗？您可以在手机APP上完成语音基础培训，获得语音徽章就可以申请语音的任务。</td>
                </tr>
                <tr>
                  <td class="black">对方不想做语音</td>
                  <td>好的，是您那边环境不适合做语音吗？那您可以在APP上完成在线基础培训，获得相关的在线徽章就可以申请在线的任务。</td>
                </tr>
                <tr>
                  <td class="blue">结束语</td>
                  <td class="black"></td>
                  <td>请尽快去APP上学习，我就不打扰您了，感谢您的接听，祝您生活愉快，再见！</td>
                </tr>
                <tr>
                  <td rowspan="11" class="blue">其<br />他<br />常<br />见<br />问<br />题</td>
                  <td class="black">有工作，没时间</td>
                  <td>好的，您以后有需要了欢迎您随时回来。</td>
                </tr>
                <tr>
                  <td class="black">有工作但晚上有时间</td>
                  <td>您这种情况呢，我这边是建议您可以尝试做在线客服，在线任务的时间安排相对来说更自由一些。</td>
                </tr>
                <tr>
                  <td class="black">询问工资怎么计算</td>
                  <td>报酬是根据任务而定的，不同的任务，报酬也不同；常见的形式是时薪。</td>
                </tr>
                <tr>
                  <td class="black">培训收费吗</td>
                  <td>您放心，我们平台承诺大家在整个过程中都是完全免费的，不收取任何一分钱的费用。</td>
                </tr>
                <tr>
                  <td class="black">什么是在线客服？</td>
                  <td>在线客服主要是通过文字和顾客交流，跟淘宝上的客服一样的。</td>
                </tr>
                <tr>
                  <td class="black">什么是语音客服？</td>
                  <td>语音客服主要是通过电话和顾客交流，就是电话销售。</td>
                </tr>
                <tr>
                  <td class="black">学习课程中有问题</td>
                  <td>这个情况的话，您可以在APP上反馈给班主任，班主任那边可以帮您解决。</td>
                </tr>
                <tr>
                  <td class="black">已经上岗</td>
                  <td>好的，如果您执行任务中有任务问题，都可以直接反馈给主管，那我就不打扰您了，祝您生活愉快，再见！</td>
                </tr>
                <tr>
                  <td class="black">是我家人注册的</td>
                  <td>那您知道您家人是想在我们平台做语音客服还是在线客服吗？目前是否已经上岗了呢？</td>
                </tr>
                <tr>
                  <td class="black">做不好会有扣罚吗</td>
                  <td>这个也是视任务而定的，等申请任务之后，任务老师也会给您们提前说明扣罚的。</td>
                </tr>
                <tr>
                  <td class="black">我随便下载的，我不清楚你们是做什么的</td>
                  <td>我简单的给您介绍下我们平台，我们淘金是2015年成立，是客服外包平台，客服是在家执行任务，获得报酬，而且我们的任务大多是长期的，在家就可以在平台上获得稳定的收入，我们执行任务的时间也比较灵活，您可以用您平时的空闲时间来平台做任务。</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="test-outer-container">
          <div class="opertiontip-box tip-four" v-if="isShowStepFour && clickFlag === 3 && stepactive === 3">
         
      <div class="tip-text">
        <p>学习时间180秒后可以开始测试</p>
        <el-button class="btn" type="primary" @click="closeStep">确定</el-button>
      </div>
      <div class="tip-quan positionimgbox">
        <img class="tip-quan_positionimg" src="../../../static/tip-quan-down.png" />
      </div>
      <div class="opertiontip">
        <div class="step-tip">
          <div class="result" v-if="status == 'AlreadyTheoryBadge' || status == 'NoTheoryBadge'">
            <p class="tip">温馨提示：<font color="red"><b>每天只能进行一次测试，外呼时请参考话术内容。</b></font>准备好即可开始测试，请珍惜测试机会。</p>
          </div>
          <div class="result" v-if="status == 'Failed'">
            <p class="failtext">很遗憾，测试未通过！</p>
            <div class="reason">未通过原因：<span v-html="result"></span></div>
          </div>
        </div>
      </div>
    </div>
      <div class="result" v-if="status == 'AlreadyTheoryBadge' || status == 'NoTheoryBadge'">
        <p class="tip">温馨提示：<font color="red"><b>每天只能进行一次测试，外呼时请参考话术内容。</b></font>准备好即可开始测试，请珍惜测试机会。</p>
        <el-button class="btn hui" type="primary" v-if="miaotwo !== 0 && stepactive === 3">开始测试({{ miaotwo }}s)</el-button>
        <el-button class="btn" type="primary" v-else @click="startExam" :disabled="isDisable">开始测试</el-button>
      </div>
      <div class="result" v-if="status == 'Failed'">
        <p class="failtext">很遗憾，测试未通过！</p>
        <div class="reason">未通过原因：<span v-html="result"></span></div>
        <p v-if="retry == 'true'">
          <!-- <el-button class="btn hui" type="primary" v-if="miaotwo !== 0 && stepactive === 3">重新测试({{ miaotwo }}s)</el-button> -->
          <el-button class="btn" type="primary"  @click="replyBegin" :disabled="isDisable">重新测试</el-button>
        </p>
        <p v-if="retry == 'false'">请按照上面提示进行操作！</p>
      </div>
      </div>
      <div v-if="status == 'Ongoing'">
        <div class="on">
           <img src="https://tj-college.oss-cn-hangzhou.aliyuncs.com/prd/studyCenterWeb/web/%E4%BB%BB%E5%8A%A1%E6%89%93%E5%8D%A12.png" alt="">
          <!-- <p class="red" style="color: #333;">接下来请你打开“淘金小助手”，按照以下步骤操作：</p>
          <p class="red"> 第一步：刷新小助手（刷新之后才会显示打卡）</p> 
          <img src="http://taojinyun.file.itaojin.cn/2021-01/f87463e52eac479d8aea0fc5d33ed085.png">
          <p class="red"> 第二步：完成打卡（不知道如何打卡，请回顾前面的打卡视频）</p> 
          <img src="http://taojinyun.file.itaojin.cn/2021-01/8979fba4bab54e5981491ac24071a8f4">
          <p class="red"> 第三步：签入sip话机</p> 
          <img src="http://taojinyun.file.itaojin.cn/2021-01/d9e056cc1ae34590b1ccdee489056a74.png">
          <p class="red"> 第四步：领取数据、外呼</p> 
          <img src="http://taojinyun.file.itaojin.cn/2021-01/d4dbf3bbc0e54727b6c8c801db701e1b.png">
          <p class="red"> 第五步：如果你耳麦有问题，系统审核员会发起远程，帮你调试耳麦，请点击确认</p> 
          <img src="http://taojinyun.file.itaojin.cn/2021-01/4c732d78177f4694a73d0e745cafd5c5.png">
          <p class="red" style="color: #333;"> 外呼完成后，请等待审核结果。</p> -->
        </div>
        <p @click="getCurrentStep"><el-button type="primary" class="btn" icon="el-icon-refresh">点击刷新审核结果</el-button></p>
      </div>
      <!--获得徽章-->
    </div>
    <div class="opertion otheropertion" v-if="clickFlag >= 4">
      <div class="pass password" v-if="status == 'Passed'">
        <p>恭喜你！</p>
        <p>你已经通过系统测试</p>
        <p v-if="Finished!=='yes'">快去完成“技能提升”的学习与测试吧！</p>
        <div class="button_box">


     <div class="btn-box button_box" v-if=" registration==1 ">
        <span  @click="relearn" class="button_again">点击重新学习</span>
          <span @click="sign_up">去查看报名场次</span>
        <!-- <span @click="returnCourseList">继续学习</span> -->
      </div>
      <!-- 未报名 -->
      <div class="btn-box button_box" v-if=" registration==0 ">
        <span  @click="relearn" class="button_again">点击重新学习</span>
          <span @click="sign_up">去报名</span>
        <!-- <span @click="returnCourseList">继续学习</span> -->
      </div>

     

          <!-- <div :class="Finished!=='yes'?'button_box1':'other_button_box1'" @click="relearn">  
            <div :class="Finished!=='yes'?'to_finish':'relearn_button'">点击重新学习</div></div>
         
          <div v-if="Finished!=='yes'" class="button_box2" @click="goguide">
            <div class="relearn_button">去完成</div> </div> -->
          </div>
        
        <!-- <img src="/tjkStudy/static/yyxr.jpg" /> -->
      </div>
    </div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      isDisable: false,
      toptab: '', //语音or在线
      stepactive: 1, //当前进度
      clickFlag: 1, //进度条是否可点击
      leadId: '',
      videoindex: [], //视频是否全部看完
    	tabCurrent: 'first', //当前标签页
      status: '', //考核状态
      retry: '', //是否可重新测试
      result: '', //未通过原因
      miaoone: 480, //倒计时480s
      timerone: null,
      miaotwo: 180, //倒计时180s
      timertwo: null,
      isShowStepOne: false,
      isShowStepTwo: false,
      isShowStepThird: false,
      isShowStepFour: false,
      isSmallpop:'',
      isokisSmallpop:0,
      Finished:'' ,//任务指南是否完成
      type:'',//跳转任务指南参数type
      tabMajorId:'',//任务指南参数id
      tabList:[],//跳任务指南（参数）
      isAllComplete:0,
      registration:0 ,   //判断是否报名

    }
  },
  created() {
    this.isokisSmallpop=0
    this.getCurrentStep();
    this.getTabList()
    
    
if(localStorage.getItem('Finished')){
  this.Finished=localStorage.getItem('Finished')
}
    
    console.log(this.Finished )

  },
  mounted() {
    
		document.getElementById(this.tabCurrent).addEventListener('ended', () => { //该视频播放是否已结束
      $('#stoptip-'+this.tabCurrent).show();
    }, false);
  },
  methods: {
        sign_up(){
  // console.log(this.tabMajorId,951)
  localStorage.setItem('trainState','no')
  
window.location.href = '/tjkStudy/train/index?type=SkillUpgrade'+'&tabMajorId='+this.tabMajorId+'&show=yes';

},
     // 去报名
    Gosignup(){
    if( this.registration==null || 0){
    window.location.href = '/tjkStudy/train/index?type=SkillUpgrade'+'&tabMajorId='+this.tabMajorId+'&show=yes';

     }
    },
  //获取技能提升列表
    getTrainList() {
      this.$http.post(API_ROOT.college + "/preWorkTrain/customer/queryTrainListWeb", {
          majorId: this.tabMajorId,
        })
        .then(
          (res) => {
          
            var result = res.data;
            if (result.success) {
              this.trainList = result.data.trainList;
              this.newPeopleBadgeId=result.data.newPeopleBadgeId
              this.needFinish=result.data.needFinish
           
              
              for(var i of this.trainList)
                //  this.trainList.forEach((item) => 
                 {
                if(i.passState =='signTimeOut' ||(i.passState == 'examUnPassed' && i.passState != 'signTimeOut') ||i.passState == 'noExam' ){
                  this.registration=0
                 
                  
                }else if(i.passState=='passed'){
                  this.registration=1 
                   
                  break
                }
                else if((i.passState != 'noJoin' && i.sign != 'Yes' && i.passState != 'signTimeOut' && i.passState != 'examUnPassed' && i.passState != 'noExam') ||(i.sign =='Yes' && i.passState != 'signTimeOut' && i.passState != 'unPassed' && i.passState != 'examUnPassed' && i.passState != 'noExam' && i.passState != 'signTimeOut') ){this.registration=1 
                  
                break}
               
              };
               localStorage.setItem('registration',this.registration)
            
        
             

              this.content = result.data.content;
            } else {
              this.$alert(result.msg);
            }
            
        
 
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/preWorkTrain/customer/queryTrainListWeb）！"
            );
          }
        );
    },
    //获取淘金文化列表
    getCourseList() {
      this.$http
        .post(API_ROOT.college + '/majors/queryCourseViewNewXlk', {
          majorId: this.tabMajorId,
        }).then((res) => {
            var result = res.data;
            if (result.success) {
              
              this.courseList = result.data.data.courseViewList;
           
              //判断是否全部不完成

            this.courseList.forEach((item) => {
             if(item.passState=='Passed'){this.isAllComplete++}
              });
            if(this.isAllComplete==this.courseList.length){
               this.Finished='yes'
                  console.log(this.courseList,2546)
            }
            } else {
              this.$alert(result.msg);
            }
          },
          (res) => {
            this.$alert("AJAX请求接口异常（/majors/queryCourseViewNewXlk）！");
          }
        );
    },
    //点击重新学习
    relearn(){
this.clickFlag=1

    },
// 查询跳转条件
 getTabList() {
      this.$http.post(API_ROOT.college + "/majorAll/showTab").then(
        (res) => {
          var result = res.data;
          if (result.success) {
            this.tabList = result.data;
            this.type=this.tabList[1].type
            this.tabMajorId=this.tabList[1].id
            this.getCourseList()
            console.log( this.tabMajorId)
            }
          } 
 
       
      );
    },
    //点击去成跳任务指南
    goguide(){
window.location.href="/tjkStudy/train/index?type="+this.type+'&tabMajorId='+this.tabMajorId
    },
    //点击刷新审核结果
      Smallpop() {
       
        this.$alert(this.isSmallpop,'', {
          confirmButtonText: '确定',
          // callback: action => {
          //   this.$message({
          //     type: 'info',
          //     message: `action: ${ action }`
          //   });
          // }
        });
      },
  	//tab切换
  	handleClick(event) {
  		document.getElementById(this.tabCurrent).play();
      //初始化其他视频
  		$('.js-video video').not('#'+this.tabCurrent).each(function(i) {
  			var tabId = $(this).attr('id');
  			document.getElementById(tabId).pause();
  			document.getElementById(tabId).currentTime = 0;
  		});
      document.getElementById(this.tabCurrent).addEventListener('ended', () => { //该视频播放是否已结束
        $('#stoptip-'+this.tabCurrent).show();
      }, false);
    },
    //重播
    restartVideo() {
      document.getElementById(this.tabCurrent).play();
      $('#stoptip-'+this.tabCurrent).hide();
    },
    //下一关
    studyNext(next) {
      $('#stoptip-'+this.tabCurrent).hide();
      document.getElementById(this.tabCurrent).currentTime = 0;
      $(next).click();
    },
    //进入测试须知
    studyNextLast() {
      this.stepactive++;
      this.clickFlag++;
      this.saveStep(2);
      if(this.stepactive === 2) {
        this.countdownOne(480);
      }
    },
    //进度条切换
    showStep(val) {
      this.clickFlag = val;
    },
    //查询当前进度
    getCurrentStep() {
      this.$http.post(API_ROOT.college + '/badge/queryTjkTrainInfo').then(res=> {
        var result = res.data;
      

        if(result.success) {
        
          this.stepactive = result.data.step ? parseInt(result.data.step) : 1;
          this.clickFlag = result.data.step ? parseInt(result.data.step) : 1;
          this.leadId = result.data.leadId ? result.data.leadId : '';
          this.status = result.data.status;
          this.retry = result.data.retry;
          this.result = result.data.result;
          this.toptab = result.data.intent;
          this.isSmallpop=result.msg
          console.log(this.isSmallpop,111)
          if(this.status=='Passed'){
            
            
          }
            if(this.isSmallpop !==''&&this.isokisSmallpop==0){this.isokisSmallpop=1}else{
              this.Smallpop()
            }
           

          if(this.clickFlag == 1) {
            this.addRecord('START', 1);
            console.log(1)
          }
          //测试须知倒计时
          if(this.stepactive === 2 && this.clickFlag === 2) {
            this.countdownOne(480);
            console.log(2)
          }
          //开始测试提示层
          if(this.stepactive === 3 && this.clickFlag === 3 && (this.status == 'AlreadyTheoryBadge' || this.status == 'NoTheoryBadge' || (this.status == 'Failed' && this.retry == 'true'))) {
            this.isShowStepOne = true;
            console.log(3)
          }
        }else {
          this.$alert(result.msg);
          console.log(4)
        }
      },res=> {
        console.log(5)
        this.$alert("AJAX请求接口异常（/badge/queryTjkTrainInfo）！");
      })
    },
    //保存当前进度
    saveStep(step) {
      let data = {
        'step': step,
        'leadId': this.leadId
      }
      this.$http.post(API_ROOT.college + '/train/view/saveTrainLead', data).then(res=> {
        var result = res.data;
        if(result.success) {
          this.leadId = result.data;
        }else {
          this.$alert(result.msg);
        }
      },res=> {
        this.$alert("AJAX请求接口异常（/train/view/saveTrainLead）！");
      })
    },
    //我已知晓
    goNext() {
      if(this.stepactive === 2) {
        this.isShowStepOne = true;
      }
      this.stepactive = 3;
      this.clickFlag = 3;
      this.saveStep(3);
      this.addRecord('START', 2);
      // this.closeStep();
    },
    showStepTwo() {
      this.isShowStepOne = false;
      this.isShowStepTwo = true;
    },
    showStepThird() {
      this.isShowStepTwo = false;
      this.isShowStepThird = true;
    },
    showStepFour() {
      this.isShowStepThird = false;
      this.isShowStepFour = true;
    },
    closeStep() {
      this.isShowStepFour = false;
      this.countdownTwo(180);
    },
    //开始测试
    startExam() {
      if(this.status == 'NoTheoryBadge') {
        this.$alert('您还不符合测试条件，请前往淘金云客服APP，点击"培训"，完成"语音客服培训"后，才能测试。');
        return;
      }
      this.applyTask();
      this.addRecord('START', 3);
    },
    //重新测试
    replyBegin() {
      this.applyTask();
      this.addRecord('START', 4);
    },
    applyTask() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.isDisable = true;

      this.$http.post(API_ROOT.college + '/badge/applyTaskApp').then(res=> {
        var result = res.data;
        if(result.success) {
          this.status = result.data.status;
          this.callHawkeye();
        }else {
          this.$alert(result.msg);
        }
        loading.close();
        this.isDisable = false;
      },res=> {
        loading.close();
        this.isDisable = false;
        this.$alert("AJAX请求接口异常（/badge/applyTaskApp）！");
      })
    },
    //调用小助手引导功能
    callHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/start').then(response=> {
        var result = response.data;
        if(result.success) {
          
        }else {
          this.$alert(result.msg);
        }
      },response=> {
        
      })
    },
    //倒计时480秒
    countdownOne(endTime) {
      var self = this;
      self.timerone = setInterval(function() {
        endTime--;
        if(endTime >= 1) {
          var sec = parseInt(endTime);
          self.miaoone = sec;
        }else {
          clearInterval(self.timerone);
          self.miaoone = 0;
        }
      }, 1000);
    },
    //倒计时180秒
    countdownTwo(endTime) {
      var self = this;
      self.timertwo = setInterval(function() {
        endTime--;
        if(endTime >= 1) {
          var sec = parseInt(endTime);
          self.miaotwo = sec;
        }else {
          clearInterval(self.timertwo);
          self.miaotwo = 0;
        }
      }, 1000);
    },
    //记录接口
    addRecord(type, index) {
      var data = {
        exerciseType: 'ASSITANT',
        stepSeq: index,
        exerciseAction: type
      }
      this.$http.post(API_ROOT.newcustomer + '/simulationExercise/addRecord', data).then(res=> {
        var result = res.data;
        if(result.success) {
          
        }else {
          this.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 1000
          })
        }
      },res=> {
        this.$message({
          message: "AJAX请求接口异常（/simulationExercise/addRecord）！",
          type: 'error',
          center: true,
          duration: 1000
        })
      })
    }
  } 
}
</script>
<style scoped>
.positionimgbox{text-align: left !important;}
.tip-quan_positionimg{margin-left: 250px;}
.password>p{font-size: 20px !important; color:red; font-weight:normal !important;
    padding-bottom: 0px !important;}
    .otheropertion{padding-top: 139px !important;}
    .button_box{margin-top: 50px;display: flex;justify-content:center;}
    .button_box1{padding-right: 5%;}
    .button_box2{padding-left: 5%;}
    .other_button_box1{padding-right:0}
  /deep/ .el-button--primary {font-size: 16px !important;}
  /deep/ .el-button {border-radius: 20px;}
  .to_finish{display: inline-block;
  font-size: 16px;
    
    background-color:#d3d5d7;
    width: 127px;
    height: 42px;
    height: 36px;
    border-radius: 18px;
    color: #898a8c;
    text-align: center;
    line-height: 36px;
    cursor: pointer;}
    .relearn_button{display: inline-block;
  font-size: 16px;
   background-color: #497AF2;
    width: 127px;
    height: 42px;
    height: 36px;
    border-radius: 18px;
    color: #fff;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
    }
    .button_box {margin-top: 30px !important;}
.button_box > span {font-size: 16px;
    line-height: 35px !important;height: 37px !important;}
    .otheropertion .btn-box{width: 30%;}
</style>


// WEBPACK FOOTER //
// ./src/page/train/voice.vue